<app-modal-wrapper ariaRole="dialog" ariaLabelledBy="accessibility-title" title="Accessibility">
  <div class="modal-body">
    @if (dataLoading()) {
      <app-loading-animation></app-loading-animation>
    }
    @if (dataEmpty()) {
      <div class="modal-body__error">Failed to load Accessibility. {{supportMessage()}}</div>
    }
    @if (dataAvailable()) {
      <div class="modal-body__text" [innerHTML]="accessibilityContent()"></div>
    }
  </div>
</app-modal-wrapper>